import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, Col, Row } from 'react-bootstrap'
import Select from 'react-select'
import { useStagedDevicesQuery } from '@data/device/device'
import Device, { StagedDevice } from '@data/device/model/device'

import './Modal.scss'

interface IModalProps {
  show: boolean
  data?: Device
  onSave: (device: StagedDevice) => void
  onHide: () => void
}

const SwapDeviceModal: React.FC<IModalProps> = ({ show, data, onSave, onHide }: IModalProps) => {
  const [selectedDevice, setSelectedDevice] = useState<StagedDevice>()
  const {
    data: stagedDevices = [],
    isPending,
    isError,
    refetch,
  } = useStagedDevicesQuery()

  useEffect(() => {}, [])

  return (
    <Modal
      onHide={onHide}
      show={show}
      backdrop="static"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="modal-header" closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {data
            ? 'Swap Device for #' + data.deviceId + ' (' + data.deviceName + ')'
            : 'Swap Devices'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="device-information-form">
          <Row>
            <Form.Group as={Col} controlId="formGridName">
              <Form.Label>Staged Device:</Form.Label>
              <Select
                classNamePrefix="select"
                value={selectedDevice}
                onChange={(d: any) => setSelectedDevice(d)}
                options={stagedDevices}
                getOptionValue={(option) => option.deviceId}
                getOptionLabel={(option) => `${option.deviceName}`}
                isClearable={false}
                isLoading={isPending}
                isDisabled={isPending || isError}
                placeholder={isPending ? 'Loading staged devices…' : 'Select…'}
                noOptionsMessage={() => 'No staged devices available'}
              />
              {isError ? (
                <div className="mt-2">
                  <span className="text-danger">Could not load staged devices.</span>
                  <Button
                    variant="link"
                    size="sm"
                    onClick={() => void refetch()}
                  >
                    Retry
                  </Button>
                </div>
              ) : null}
            </Form.Group>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button disabled={!selectedDevice} onClick={() => onSave(selectedDevice!)}>
          Activate Device
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SwapDeviceModal
